import styled from "styled-components";
import {
  Button,
  CircularProgress,
  TextField,
  FormControl,
} from "@mui/material";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
`;

export const LoadingSpinner = styled(CircularProgress).attrs({
  color: "success",
})``;


export const LoginBox = styled.div`
  padding: 2rem;
  width: 100%;
  max-width: 400px;
`;

export const Title = styled.div`
  font-size: 1rem;
  font-weight: 800;
  margin-bottom: 1rem;
  text-align: left;
  color: #1e2f23;
`;

export const Subtitle = styled.div`
  font-size: 0.875rem;
  margin-bottom: 1rem;
  text-align: left;
  color: #666;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
`;

export const StyledFormControl = styled(FormControl)`
  width: calc(100% - 48px);
  margin-top: 12px;

  .MuiInputLabel-root {
    font-weight: 700 !important;
    color: #e39435 !important;
  }

  .MuiInputBase-root {
    font-weight: 700 !important;
    color: #e39435 !important;
  }
`;

export const StyledTextField = styled(TextField)`
  .MuiInputBase-input {
    &::placeholder {
      color: #adadad;
      opacity: 1;
    }
    font-size: 16px;
    font-weight: 700;
    color: #1e2f23;
  }

  .MuiFormHelperText-root {
    margin-left: 0;
  }
`;

export const StyledButton = styled(Button).attrs({
  variant: "contained",
  sx: {
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
    border: "1px solid #E2E2E2",
  },
})<{ isvalid: boolean }>`
  width: 100%;
  border: none;
  padding: ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  height: 48px;
  border-radius: 8px;
  background-color: ${({ isvalid }) => (isvalid ? "#E39435" : "#E0E0E0")};
  color: ${({ isvalid }) => (isvalid ? "white" : "#9E9E9E")};

  &:hover {
    background-color: ${({ isvalid }) => (isvalid ? "#D1872B" : "#E0E0E0")};
  }
`;

export const ErrorMessage = styled.p`
  color: #d32f2f;
  font-size: 0.875rem;
  margin-bottom: 2rem;
  text-align: left;
`;

export const StyledEmailIcon = styled(LocalPostOfficeIcon)`
  margin-top: 0.5rem;
  margin-right: 0.5rem;
  color: #e39435;
`;
